import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { brand } from '../config/brand';
import Welcome from '../pages/Welcome';

const RootRedirect: React.FC = () => {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
      </div>
    );
  }

  // If user is logged in, redirect to the brand's default landing route.
  if (user) {
    return <Navigate to={brand.defaultRoute} replace />;
  }

  // If not logged in, show welcome page
  return <Welcome />;
};

export default RootRedirect;
